import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=55e3abfa&scoped=true&"
import script from "./ship.vue?vue&type=script&lang=js&"
export * from "./ship.vue?vue&type=script&lang=js&"
import style0 from "./ship.vue?vue&type=style&index=0&id=55e3abfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3abfa",
  null
  
)

export default component.exports